import React, { useMemo } from 'react';
import { Select } from 'baseui/select';
import type { OnChangeParams, SelectOverrides } from 'baseui/select';
import type { EnhancedQuestion, Answer, RenderTextArgs } from '../../types';
import { getErrorMessageFromQuestion, getPlaceholder } from '../../utils';
import { TextType } from '../../constants';
export type SelectInputProps = {
  question: EnhancedQuestion;
  answer?: Answer;
  overrides?: SelectOverrides;
  setAnswerForQuestion: (questionId: string, answers: string[]) => void;
  renderText: (args: RenderTextArgs) => React.ReactNode | null;
};
const SelectInput = ({
  question,
  answer,
  overrides,
  setAnswerForQuestion,
  renderText
}: SelectInputProps) => {
  const value = useMemo(() => {
    return answer?.answers.map(answer => ({
      label: answer,
      id: answer
    }));
  }, [answer]);
  const placeholder: React.ReactNode | undefined = useMemo(() => {
    const placeholderFromConsumer = renderText({
      question,
      textType: TextType.SELECT_PLACEHOLDER
    });
    return placeholderFromConsumer ?? getPlaceholder(question.tags);
  }, [question, renderText]);
  const onChange = (e: OnChangeParams) => {
    setAnswerForQuestion(question.id, e.value.filter(value => Boolean(value?.id)).map(value => (value.id as string)));
  };

  // Enable multi-select only when answerLimit is defined and greater than 1
  const isMultiSelect = question.answerLimit != null && question.answerLimit !== 1;
  return <Select multi={isMultiSelect} options={question?.answerOptions.map(option => ({
    label: option.answer,
    id: option.answer
  }))} value={value} overrides={overrides} placeholder={placeholder} error={!!getErrorMessageFromQuestion(question)} onChange={onChange} />;
};
export default SelectInput;